import React, { useEffect } from "react";
import RelatedPost from "./RelatedPost";
import { useDispatch, useSelector } from "react-redux";
import { relatedPosts } from "../features/relatedPosts/relatedPostsSlice";

export default function RelatedPosts({ post }) {
  const dispatch = useDispatch();
  const { posts, isLoading } = useSelector((state) => state.relatedPosts);

  useEffect(() => {
    dispatch(relatedPosts(post));
  }, [dispatch, post]);

  let content = "";

  if (isLoading) {
    content = "Loading...";
  } else if (!isLoading && posts?.length === 0) {
    content = "No related post found.";
  } else if (posts?.length > 0) {
    content = posts.map((post) => <RelatedPost key={post.id} post={post} />);
  } else {
    content = "something is wrong";
  }

  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">{content}</div>
    </aside>
  );
}
